import React from 'react';
import { Plus, Eye, Edit, Trash2, Copy, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Link, useNavigate } from 'react-router-dom';
export function ManageCourses() {
  const navigate = useNavigate();
  const courses = [{
    pos: 1,
    courseNo: 'CD17355',
    name: 'Ethics & The Rules (with NAR Code of Ethics)',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 2,
    courseNo: 'None',
    name: 'NAR Code of Ethics (NO CE CREDIT)',
    sections: 5,
    questions: 27,
    passing: 80,
    price: '$14.95  (N)',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 3,
    courseNo: 'FWD17590',
    name: 'Deeds, Fires & Water: Be Prepared',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 5,
    courseNo: 'CD16995',
    name: 'Are They Represented?',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 6,
    courseNo: 'CD18311',
    name: 'Mastering Agency Agreements',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 8,
    courseNo: 'CD16991',
    name: 'A Letter From ADRE',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 9,
    courseNo: 'CD17085',
    name: "Don't Lose Your License",
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 10,
    courseNo: 'CD17707',
    name: 'BMC #1 AZ Residential-Statutes and Rules',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 11,
    courseNo: 'CD17708',
    name: 'BMC #2 AZ Residential-Broker Policies',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 12,
    courseNo: 'CD17709',
    name: 'BMC #3 AZ Residential-Broker Supervision',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 13,
    courseNo: 'CD18092',
    name: 'BMC #3B Property Management',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 14,
    courseNo: 'CD16990',
    name: 'What Goes Wrong In Contracts',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 15,
    courseNo: 'CD18093',
    name: 'Avoid The Oops: Contract Smarts for Agents',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 17,
    courseNo: 'CD16992',
    name: 'No Secrets',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 18,
    courseNo: 'CD18149',
    name: 'The Bottom Line of Disclosure',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 19,
    courseNo: 'CE15753',
    name: 'Your Clients Are Not Mushrooms',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 20,
    courseNo: 'CD16993',
    name: 'They Are A Protected Class',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 21,
    courseNo: 'CD15797',
    name: "Fair Housing In Today's World",
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: 'They Are A Protected Class'
  }, {
    pos: 23,
    courseNo: 'CE17700',
    name: 'Accidental Property Management',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 24,
    courseNo: 'CD16994',
    name: 'Follow All The Laws',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }];
  return <div className="space-y-6" data-id="element-1149">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1150">Manage Courses</h1>

      <div className="mb-4" data-id="element-1151">
        <Button variant="secondary" size="sm" className="gap-2 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm hover:from-slate-50 hover:to-slate-200" onClick={() => navigate('/courses/add')} data-id="element-1152">
          <Plus className="h-4 w-4 text-green-600" data-id="element-1153" />
          Add
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1154">
        <div className="overflow-x-auto" data-id="element-1155">
          <table className="w-full text-sm text-left" data-id="element-1156">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1157">
              <tr data-id="element-1158">
                <th className="px-2 py-3 border-r border-slate-700 text-center w-16" data-id="element-1159">
                  Position
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-24" data-id="element-1160">
                  Course No
                </th>
                <th className="px-4 py-3 border-r border-slate-700 text-center" data-id="element-1161">
                  Name
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-16" data-id="element-1162">
                  Sections
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-20" data-id="element-1163">
                  Questions
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-20" data-id="element-1164">
                  Passing(%)
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1165">
                  Price
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-20" data-id="element-1166">
                  Published
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-32" data-id="element-1167">
                  Renewed To
                </th>
                <th className="px-4 py-3 text-center w-44" data-id="element-1168">
                  <div data-id="element-1169">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1170">
                    View | Edit | Delete | Clone | Renew
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1171">
              {courses.map(course => <tr key={course.pos} className="hover:bg-slate-50" data-id="element-1172">
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1173">
                    {course.pos}
                  </td>
                  <td className="px-3 py-3 border-r border-slate-200" data-id="element-1174">
                    {course.courseNo}
                  </td>
                  <td className="px-4 py-3 border-r border-slate-200" data-id="element-1175">
                    {course.name}
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1176">
                    <button className="text-blue-600 hover:underline" onClick={() => navigate(`/courses/${course.pos}/sections`)} data-id="element-1177">
                      {course.sections}
                    </button>
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1178">
                    {course.questions}
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1179">
                    {course.passing}
                  </td>
                  <td className="px-3 py-3 border-r border-slate-200" data-id="element-1180">
                    {course.price}
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1181">
                    {course.published}
                  </td>
                  <td className="px-3 py-3 border-r border-slate-200 text-slate-700" data-id="element-1182">
                    {course.renewedTo}
                  </td>
                  <td className="px-4 py-3 text-center" data-id="element-1183">
                    <div className="flex items-center justify-center gap-2" data-id="element-1184">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/courses/view/${course.pos}`)} data-id="element-1185">
                        <Eye className="h-4 w-4" data-id="element-1186" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/courses/edit/${course.pos}`)} data-id="element-1187">
                        <Edit className="h-4 w-4" data-id="element-1188" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1189">
                        <Trash2 className="h-4 w-4" data-id="element-1190" />
                      </button>
                      <button title="Clone" className="p-1 text-slate-500 hover:text-blue-600" data-id="element-1191">
                        <Copy className="h-4 w-4" data-id="element-1192" />
                      </button>
                      <button title="Renew" className="p-1 text-slate-500 hover:text-green-600" data-id="element-1193">
                        <RefreshCw className="h-4 w-4" data-id="element-1194" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-1195">
        <button className="hover:underline" data-id="element-1196">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-1197">|</span>
        <span className="text-slate-900 font-medium" data-id="element-1198">1</span>
        <span className="text-slate-400" data-id="element-1199">|</span>
        <button className="hover:underline" data-id="element-1200">2</button>
        <span className="text-slate-400" data-id="element-1201">|</span>
        <button className="hover:underline" data-id="element-1202">3</button>
        <span className="text-slate-400" data-id="element-1203">|</span>
        <button className="hover:underline" data-id="element-1204">next &gt;&gt;</button>
      </div>
    </div>;
}